// src/pages/components/ProjectDetailsDangerZone.js
import { useState } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Stack,
  Typography,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ProjectDetailsDangerZone = ({ projectId }) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleOpen = () => {
    setError('');
    setOpen(true);
  };

  const handleClose = () => {
    if (deleting) return;
    setOpen(false);
    setError('');
  };

  const handleDelete = async () => {
    if (!projectId || deleting) return;

    try {
      setDeleting(true);
      setError('');

      await axios.delete(`/api/v1/project/${projectId}`);

      // After delete, return to projects dashboard
      navigate('/projects');
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || 'Failed to delete project.';
      setError(msg);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      <Paper variant="outlined" sx={{ p: 2, position: 'relative', mb: 5 }}>
        <Typography
          color="text.secondary"
          variant="caption"
          sx={{
            position: 'absolute',
            top: -8,
            left: 12,
            backgroundColor: 'background.paper',
            px: 0.5,
            fontWeight: 700,
          }}
        >
          Danger Zone
        </Typography>

        <Stack spacing={1}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }} justifyContent="space-between">
            <Box>
              <Typography variant="body2" color="text.secondary">
                This will remove the project and its associations.
              </Typography>
            </Box>

            <Button variant="outlined" color="error" onClick={handleOpen}>
              Delete project
            </Button>
          </Stack>
        </Stack>
      </Paper>

      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Delete project?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            This action cannot be undone. The project and its associations will be permanently removed.
          </Typography>

          {error ? (
            <Typography variant="body2" color="error" sx={{ mt: 2 }}>
              {error}
            </Typography>
          ) : null}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose} disabled={deleting}>
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            variant="contained"
            color="error"
            disabled={deleting}
            startIcon={deleting ? <CircularProgress size={16} /> : null}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProjectDetailsDangerZone;
